import { ReactElement } from 'react';
import { Grid, Typography, Box, Divider, Container } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Formik } from 'formik';
import {
    AppPrimaryButton,
    AppSecondaryButton,
    AppPrimaryButtonOutlined,
    AppSecondaryButtonOutlined,
    AppTeritaryButton,
    AppFormikTextField,
    AppFormikTextArea,
} from './AppComponents';

const DesignBook = (): ReactElement => (
    // UI Elements
    <Container maxWidth="md">
        <Grid id="design-book" container>
            <Grid item xs={12}>
                <Box my={2}>
                    <Typography variant="h4">Typography</Typography>
                    <Divider />
                </Box>
                <Typography variant="h1">Heading H1</Typography>
                <Typography variant="h2">Heading H2</Typography>
                <Typography variant="h3">Heading h3</Typography>
                <Typography variant="h4">Heading h4</Typography>
                <Typography variant="h5">Heading h5</Typography>
                <Typography variant="h6">Heading h6</Typography>
                <Typography variant="body1">Body 1</Typography>
                <Typography variant="body2">Body 2</Typography>
                <Typography variant="caption">Caption</Typography>
            </Grid>
            <Grid item xs={12}>
                <Box mt={2}>
                    <Box my={2}>
                        <Typography variant="h2">Text Field</Typography>
                        <Divider />
                    </Box>
                    <Formik
                        initialValues={{
                            smallInput: 'Small Input',
                            largeInput: 'Large Input',
                            password: '',
                            multiLine: 'Multiline',
                            readOnly: 'Read only',
                        }}
                        enableReinitialize
                        onSubmit={() => {
                            // console.log('');
                        }}
                    >
                        {() => (
                            <Grid item xs={12}>
                                <AppFormikTextField
                                    name="smallInput"
                                    label="Small Input"
                                    size="small"
                                />
                                <AppFormikTextField
                                    name="largeInput"
                                    label="Large Input"
                                    size="medium"
                                />
                                <AppFormikTextField
                                    name="readOnly"
                                    label="Read only"
                                    size="medium"
                                    readOnly
                                />
                                <AppFormikTextField name="password" />
                                <AppFormikTextArea
                                    name="multiLine"
                                    label="Multi Line"
                                    rows={4}
                                />
                            </Grid>
                        )}
                    </Formik>
                </Box>
                <Box mt={2}>
                    <Box my={2}>
                        <Typography variant="h3">Buttons</Typography>
                        <Divider />
                    </Box>
                    <Typography variant="h4">Primary Button</Typography>
                    <AppPrimaryButton title="Primary Button" />
                    <AppPrimaryButton title="Primary Button" isLoading />
                    <AppPrimaryButton
                        title="Primary Button"
                        isLoading
                        disabled
                    />
                    <AppPrimaryButton
                        title="Primary Button With Icon"
                        endIcon={<ArrowForwardIosIcon />}
                    />
                    <AppPrimaryButton
                        title="Small Button"
                        className="btn-small"
                    />
                    <AppPrimaryButton
                        title="Small Button"
                        className="btn-small"
                        endIcon={<ArrowForwardIosIcon />}
                    />

                    <AppPrimaryButton
                        title="Extra Small Button"
                        className="btn-extra-small"
                    />
                    <AppPrimaryButton
                        title="Extra Small Button"
                        className="btn-extra-small"
                        isLoading
                    />

                    <AppPrimaryButton title="Primary Button" disabled />
                </Box>

                <Typography variant="h4">Primary Button Outlined</Typography>
                <AppPrimaryButtonOutlined title="Primary Button Outlined" />
                <AppPrimaryButtonOutlined
                    title="Primary Button Outlined"
                    isLoading
                />
                <AppPrimaryButtonOutlined
                    title="Primary Button Outlined With Icon"
                    endIcon={<ArrowForwardIosIcon />}
                />
                <AppPrimaryButtonOutlined
                    title="Small Button"
                    className="btn-small"
                />
                <AppPrimaryButtonOutlined
                    title="Small Button"
                    className="btn-small"
                    endIcon={<ArrowForwardIosIcon />}
                />
                <AppPrimaryButtonOutlined
                    title="Extra Small Button"
                    className="btn-extra-small"
                />
                <AppPrimaryButtonOutlined
                    title="Extra Small Button"
                    className="btn-extra-small"
                    isLoading
                />
                <AppPrimaryButtonOutlined
                    title="Primary Button Outlined"
                    disabled
                />

                <Box mt={2}>
                    <Typography variant="h4">Secondary Button</Typography>
                    <AppSecondaryButton title="Secondary Button" />
                    <AppSecondaryButton title="Secondary Button" isLoading />
                    <AppSecondaryButton
                        title="Secondary Button With Icon"
                        endIcon={<ArrowForwardIosIcon />}
                    />
                    <AppSecondaryButton
                        title="Small Button"
                        className="btn-small"
                    />
                    <AppSecondaryButton
                        title="Small Button"
                        className="btn-small"
                        endIcon={<ArrowForwardIosIcon />}
                    />
                    <AppSecondaryButton
                        title="Extra Small Button"
                        className="btn-extra-small"
                    />
                    <AppSecondaryButton
                        title="Extra Small Button"
                        className="btn-extra-small"
                        isLoading
                    />
                    <AppSecondaryButton
                        disabled
                        title="Disabled Button"
                        className="btn-small"
                        endIcon={<ArrowForwardIosIcon />}
                    />
                </Box>

                <Box mt={2}>
                    <Typography variant="h4">
                        Secondary Button Outlined
                    </Typography>
                    <AppSecondaryButtonOutlined title="Secondary Button Outlined" />
                    <AppSecondaryButtonOutlined
                        title="Secondary Button Outlined"
                        isLoading
                    />
                    <AppSecondaryButtonOutlined
                        title="Secondary Button Outlined With Icon"
                        endIcon={<ArrowForwardIosIcon />}
                    />
                    <AppSecondaryButtonOutlined
                        title="Small Button"
                        className="btn-small"
                    />
                    <AppSecondaryButtonOutlined
                        title="Small Button"
                        className="btn-small"
                        endIcon={<ArrowForwardIosIcon />}
                    />
                    <AppSecondaryButtonOutlined
                        title="Extra Small Button"
                        className="btn-extra-small"
                    />
                    <AppSecondaryButtonOutlined
                        title="Extra Small Button"
                        className="btn-extra-small"
                        isLoading
                    />
                    <AppSecondaryButtonOutlined
                        title="Secondary Button Outlined"
                        disabled
                    />
                </Box>

                <Box mt={2}>
                    <Typography variant="h4">Teritary Button</Typography>
                    <AppTeritaryButton title="Teritary Button" />
                    <AppTeritaryButton title="Teritary Button" isLoading />
                    <AppTeritaryButton
                        title="Teritary Button With Icon"
                        endIcon={<ArrowForwardIosIcon />}
                    />
                    <AppTeritaryButton
                        title="Small Button"
                        className="btn-small"
                    />
                    <AppTeritaryButton
                        title="Small Button"
                        className="btn-small"
                        endIcon={<ArrowForwardIosIcon />}
                    />
                    <AppTeritaryButton
                        title="Extra Small Button"
                        className="btn-extra-small"
                    />
                    <AppTeritaryButton
                        title="Extra Small Button"
                        className="btn-extra-small"
                        isLoading
                    />
                    <AppTeritaryButton title="Teritary Button" disabled />
                </Box>
            </Grid>
        </Grid>
    </Container>
);
export default DesignBook;
